export { default } from './LineItemImage';



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/LineItemImage/index.js